/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { externalCredentialsGetGcpIam } from "../funcs/externalCredentialsGetGcpIam.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GcpIamCredential } from "../models/components/gcpiamcredential.js";
import {
  GetGcpIamCredentialRequest,
  GetGcpIamCredentialSecurity,
} from "../models/operations/getgcpiamcredential.js";
import { unwrapAsync } from "../types/fp.js";
export type GetGcpIamCredentialQueryData = GcpIamCredential;

export function prefetchGetGcpIamCredential(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetGcpIamCredentialRequest,
  security?: GetGcpIamCredentialSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetGcpIamCredentialQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetGcpIamCredentialQuery(
  client$: GramCore,
  request: GetGcpIamCredentialRequest,
  security?: GetGcpIamCredentialSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetGcpIamCredentialQueryData>;
} {
  return {
    queryKey: queryKeyGetGcpIamCredential({
      id: request.id,
      gramSession: request.gramSession,
    }),
    queryFn: async function getGcpIamCredentialQueryFn(
      ctx,
    ): Promise<GetGcpIamCredentialQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(externalCredentialsGetGcpIam(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetGcpIamCredential(
  parameters: { id: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "externalCredentials", "getGcpIam", parameters];
}
